import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalContactoSoporteComponent } from '../contacto-soporte/contacto-soporte.component';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-floating-help-button',
  templateUrl: './floating-help-button.component.html',
  styleUrls: ['./floating-help-button.component.scss'],
  animations: [
    trigger('rotateScaleIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0) rotate(-180deg)' }),
        animate('600ms 800ms ease-out', style({ opacity: 1, transform: 'scale(1) rotate(0deg)' }))
      ])
    ])
  ]
})
export class FloatingHelpButtonComponent implements OnInit {

  constructor(
    private modalService: NgbModal,
    private sesionService: SesionService,
  ) { }

  ngOnInit(): void { }

  soporteLubriKuv(): void {
    const modalRef = this.modalService.open(ModalContactoSoporteComponent, { windowClass: 'clear-modal', size: 's', scrollable: true, centered: true });
    modalRef.componentInstance.soloDemo = this.sesionService.user.cuenta_prueba;
    modalRef.componentInstance.showTutorialButton = true;
    modalRef.result.then((result: any) => {
    }, (reason: any) => { });
  }
}
